import Layout from "./Layout.jsx";

import Dashboard from "./Dashboard.jsx";

import Tickets from "./Tickets.jsx";

import Clients from "./Clients.jsx";

import Projects from "./Projects.jsx";

import Settings from "./Settings.jsx";

import NewTicket from "./NewTicket.jsx";

import NewClient from "./NewClient.jsx";

import NewProject from "./NewProject.jsx";

import EditTicket from "./EditTicket.jsx";

import EditClient from "./EditClient.jsx";

import EditProject from "./EditProject.jsx";

import Knowledge from "./Knowledge.jsx";

import NewKnowledge from "./NewKnowledge.jsx";

import ViewKnowledge from "./ViewKnowledge.jsx";

import ViewTicket from "./ViewTicket.jsx";

import Users from "./Users.jsx";

import Companies from "./Companies.jsx";

import NewUser from "./NewUser.jsx";

import NewCompany from "./NewCompany.jsx";

import Systems from "./Systems.jsx";

import NewSystem from "./NewSystem.jsx";

import AdminLogin from "./AdminLogin.jsx";

import ClientLogin from "./ClientLogin.jsx";

import ClientRecovery from "./ClientRecovery.jsx";

import ViewCompany from "./ViewCompany.jsx";

import ViewSystem from "./ViewSystem.jsx";

import ViewSystemVersion from "./ViewSystemVersion.jsx";

import ViewUser from "./ViewUser.jsx";

import EditUser from "./EditUser.jsx";

import Messages from "./Messages.jsx";

import Calendar from "./Calendar.jsx";

import Timesheet from "./Timesheet.jsx";

import Reports from "./Reports.jsx";

import EditKnowledge from "./EditKnowledge.jsx";

import NewSystemVersion from "./NewSystemVersion.jsx";

import UserProfile from "./UserProfile.jsx";

import Favorites from "./Favorites.jsx";

import Notifications from "./Notifications.jsx";

import ViewProject from "./ViewProject.jsx";

import TicketComment from "./TicketComment.jsx";

import CompleteRegistration from "./CompleteRegistration.jsx";

import ViewClient from "./ViewClient.jsx";

import SystemModules from "./SystemModules.jsx";

import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import AuthGuard from '../components/auth/AuthGuard.jsx';

const PAGES = {
    
    Dashboard: Dashboard,
    
    Tickets: Tickets,
    
    Clients: Clients,
    
    Projects: Projects,
    
    Settings: Settings,
    
    NewTicket: NewTicket,
    
    NewClient: NewClient,
    
    NewProject: NewProject,
    
    EditTicket: EditTicket,
    
    EditClient: EditClient,
    
    EditProject: EditProject,
    
    Knowledge: Knowledge,
    
    NewKnowledge: NewKnowledge,
    
    ViewKnowledge: ViewKnowledge,
    
    ViewTicket: ViewTicket,
    
    Users: Users,
    
    Companies: Companies,
    
    NewUser: NewUser,
    
    NewCompany: NewCompany,
    
    Systems: Systems,
    
    NewSystem: NewSystem,
    
    AdminLogin: AdminLogin,
    
    ClientLogin: ClientLogin,
    
    ClientRecovery: ClientRecovery,
    
    ViewCompany: ViewCompany,
    
    ViewSystem: ViewSystem,
    
    ViewSystemVersion: ViewSystemVersion,
    
    ViewUser: ViewUser,
    
    EditUser: EditUser,
    
    Messages: Messages,
    
    Calendar: Calendar,
    
    Timesheet: Timesheet,
    
    Reports: Reports,
    
    EditKnowledge: EditKnowledge,
    
    NewSystemVersion: NewSystemVersion,
    
    UserProfile: UserProfile,
    
    Favorites: Favorites,
    
    Notifications: Notifications,
    
    ViewProject: ViewProject,
    
    TicketComment: TicketComment,
    
    CompleteRegistration: CompleteRegistration,
    
    ViewClient: ViewClient,
    
    SystemModules: SystemModules,
    
}

function _getCurrentPage(url) {
    if (url.endsWith('/')) {
        url = url.slice(0, -1);
    }
    
    // Se for a raiz, retornar AdminLogin
    if (url === '' || url === '/') {
        return 'AdminLogin';
    }
    
    let urlLastPart = url.split('/').pop();
    if (urlLastPart.includes('?')) {
        urlLastPart = urlLastPart.split('?')[0];
    }

    const pageName = Object.keys(PAGES).find(page => page.toLowerCase() === urlLastPart.toLowerCase());
    return pageName || 'AdminLogin';
}

// Create a wrapper component that uses useLocation inside the Router context
function PagesContent() {
    const location = useLocation();
    const currentPage = _getCurrentPage(location.pathname);
    
    return (
        <AuthGuard>
            <Layout currentPageName={currentPage}>
                <Routes>            
                
                    <Route path="/" element={<AdminLogin />} />
                
                
                <Route path="/Dashboard" element={<Dashboard />} />
                
                <Route path="/Tickets" element={<Tickets />} />
                
                <Route path="/Clients" element={<Clients />} />
                
                <Route path="/Projects" element={<Projects />} />
                
                <Route path="/Settings" element={<Settings />} />
                
                <Route path="/NewTicket" element={<NewTicket />} />
                
                <Route path="/NewClient" element={<NewClient />} />
                
                <Route path="/NewProject" element={<NewProject />} />
                
                <Route path="/EditTicket" element={<EditTicket />} />
                
                <Route path="/EditClient" element={<EditClient />} />
                
                <Route path="/EditProject" element={<EditProject />} />
                
                <Route path="/Knowledge" element={<Knowledge />} />
                
                <Route path="/NewKnowledge" element={<NewKnowledge />} />
                
                <Route path="/ViewKnowledge" element={<ViewKnowledge />} />
                
                <Route path="/ViewTicket" element={<ViewTicket />} />
                
                <Route path="/Users" element={<Users />} />
                
                <Route path="/Companies" element={<Companies />} />
                
                <Route path="/NewUser" element={<NewUser />} />
                
                <Route path="/NewCompany" element={<NewCompany />} />
                
                <Route path="/Systems" element={<Systems />} />
                
                <Route path="/NewSystem" element={<NewSystem />} />
                
                <Route path="/AdminLogin" element={<AdminLogin />} />
                
                <Route path="/ClientLogin" element={<ClientLogin />} />
                
                <Route path="/ClientRecovery" element={<ClientRecovery />} />
                
                <Route path="/ViewCompany" element={<ViewCompany />} />
                
                <Route path="/ViewSystem" element={<ViewSystem />} />
                
                <Route path="/ViewSystemVersion" element={<ViewSystemVersion />} />
                
                <Route path="/ViewUser" element={<ViewUser />} />
                
                <Route path="/EditUser" element={<EditUser />} />
                
                <Route path="/Messages" element={<Messages />} />
                
                <Route path="/Calendar" element={<Calendar />} />
                
                <Route path="/Timesheet" element={<Timesheet />} />
                
                <Route path="/Reports" element={<Reports />} />
                
                <Route path="/EditKnowledge" element={<EditKnowledge />} />
                
                <Route path="/NewSystemVersion" element={<NewSystemVersion />} />
                
                <Route path="/UserProfile" element={<UserProfile />} />
                
                <Route path="/Favorites" element={<Favorites />} />
                
                <Route path="/Notifications" element={<Notifications />} />
                
                <Route path="/ViewProject" element={<ViewProject />} />
                
                <Route path="/TicketComment" element={<TicketComment />} />
                
                <Route path="/CompleteRegistration" element={<CompleteRegistration />} />
                
                <Route path="/ViewClient" element={<ViewClient />} />
                
                <Route path="/SystemModules" element={<SystemModules />} />
                
            </Routes>
            </Layout>
        </AuthGuard>
    );
}

export default function Pages() {
    return (
        <Router
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true
            }}
        >
            <PagesContent />
        </Router>
    );
}